import axios from 'axios';

const $apiRegion = axios.create({
    baseURL: 'https://putramisel.github.io/api-wilayah-indonesia/api',
    headers: {
        'Content-Type': 'application/json'
    }
});
  
export default $apiRegion;